// Форматы дат в списке поездок и в поповере подробностей.
//
// toLocaleString() браузера тут не годится: он печатает по локали устройства,
// а не по языку, который человек выбрал в интерфейсе — те два часто расходятся
// (например, английский интерфейс на телефоне с русской локалью ОС). Intl с
// явным lang даёт ровно тот язык, что выбран в LanguagePicker.
import type { Lang } from '../i18n';

/**
 * Плитка списка: коротко — день, сокращённый месяц, время. Год добавляется,
 * только если дата не из текущего года — иначе он не несёт новой информации
 * и просто удлиняет строку, которая и так одна из самых тесных на странице.
 */
export function formatTripDateCompact(ms: number, lang: Lang): string {
  const date = new Date(ms);
  const sameYear = date.getFullYear() === new Date().getFullYear();
  return new Intl.DateTimeFormat(lang, {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    year: sameYear ? undefined : 'numeric',
  }).format(date);
}

/** Поповер с подробностями: та же дата, но полностью — там место не в дефиците. */
export function formatTripDateFull(ms: number, lang: Lang): string {
  return new Intl.DateTimeFormat(lang, { dateStyle: 'long', timeStyle: 'short' }).format(new Date(ms));
}
